
import React from 'react';
import CTAHeader from './CTASection/CTAHeader';
import CTAStats from './CTASection/CTAStats';

const CTASection = () => {
  return (
    <section className="py-16 md:py-20 bg-gradient-to-b from-gray-900 via-slate-900 to-gray-900 relative overflow-hidden">
      <div className="container mx-auto px-4">
        <CTAHeader />
        <CTAStats />
      </div>
    </section>
  );
};

export default CTASection;
